/** What the bell has to show: new leads, a review, and one billing receipt. */

import type { Notification } from '../../types';
import { daysAgo, hoursAgo } from './time';

export const demoNotifications: Notification[] = [
  {
    id: 'demo-notif-1',
    type: 'lead',
    title: 'New lead — Marcus Webb',
    message: 'Emergency repair request from the contact form.',
    link: '/leads',
    read: false,
    createdAt: hoursAgo(3),
  },
  {
    id: 'demo-notif-2',
    type: 'lead',
    title: 'New lead — Priya Raman',
    message: 'Water heater replacement quote request.',
    link: '/leads',
    read: false,
    createdAt: hoursAgo(20),
  },
  {
    id: 'demo-notif-3',
    type: 'review',
    title: 'New 5-star review on Google',
    message: 'Elaine Brooks reviewed Republic Plumbing.',
    link: '/reviews',
    read: false,
    createdAt: daysAgo(7),
  },
  {
    id: 'demo-notif-4',
    type: 'system',
    title: 'Site updated',
    message: 'Your water heater service page went live.',
    link: null,
    read: true,
    createdAt: daysAgo(6),
  },
  {
    id: 'demo-notif-5',
    type: 'billing',
    title: 'Payment received',
    message: 'Managed plan — $199.00.',
    link: null,
    read: true,
    createdAt: daysAgo(12),
  },
];

/** The bell hides lead notifications; its badge counts everything else unread. */
export const demoUnreadNonLeadCount = demoNotifications.filter(
  notification => !notification.read && notification.type !== 'lead'
).length;

export const demoUnreadNotificationCount = demoNotifications.filter(
  notification => !notification.read
).length;
